import React from 'react';
import {Route, Switch} from 'react-router-dom';

import NotificationsRedirector from '../screens/NotificationsRedirector';
import Notifications from '../screens/Notifications';

export default props => (
    <Switch>
        <Route path={`${props.match.path}/:notificationId`} component={NotificationsRedirector} />
        <Route component={Notifications} />
    </Switch>
);
